<template>
    <div class="fwd-target-setting">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">FWD Target Setting</h2>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <b-card>
                <div class="py-3 d-flex justify-content-between align-items-center">
                    <h3>Configurations</h3>
                    <button class="btn btn-primary" @click="addRowTarget">Add New</button>
                </div>
                <div class="mb-3">
                    <b-form ref="fwdTargetForm" role="form" @submit.prevent="update()">
                        <h4>Target Settings</h4>
                        <b-row class="my-3">
                            <b-col cols="3">
                                <b-form-group label="FWD Insurance Target">
                                    <b-form-input
                                        v-model="form.target"
                                        type="text"
                                        required
                                    ></b-form-input>
                                    <small class="text-danger" v-show="errors.target">FWD Insurance Target Field is required</small>
                                </b-form-group>
                            </b-col>
                            <b-col cols="3">
                                <b-form-group label="Target Duration">
                                    <el-select v-model="form.duration" placeholder="Select">
                                        <el-option
                                            v-for="item in durationOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <small class="text-danger" v-show="errors.duration">Target Duration is required</small>
                                </b-form-group>
                            </b-col>
                            <b-col cols="3">
                                <b-form-group label="Target From">
                                        <el-date-picker
                                        v-model="form.date_from"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="Pick Date From">
                                        </el-date-picker>
                                        <small class="text-danger" v-show="errors.date_from">Target From is required</small>
                                </b-form-group>
                            </b-col>
                            <b-col cols="3">
                                <b-form-group label="Target To">
                                        <el-date-picker
                                        v-model="form.date_to"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="Pick Date From">
                                        </el-date-picker>
                                        <small class="text-danger" v-show="errors.date_to">Target To is required</small>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div class="mb-5">
                            <b-table-simple responsive>
                                <b-thead>
                                    <b-tr>
                                        <b-th width="30%">Type</b-th>
                                        <b-th width="30%">Target & Duration</b-th>
                                        <b-th width="30%">From/To</b-th>
                                        <b-th width="10%">Action</b-th>
                                    </b-tr>
                                </b-thead>
                                <b-tbody>
                                    <b-tr v-for="(target, index) in targetList" :key="index">
                                        <b-td>{{ target.target }}</b-td>
                                        <b-td>{{ target.duration }}</b-td>
                                        <b-td>
                                            <p class="bottom-line">{{ target.date_from }} - {{ target.date_to }}</p>
                                        </b-td>
                                        <b-td>
                                            <div class="text-danger cursor-pointer text-center" @click="removeRowTarget(index)">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 1408 1536"><path fill="currentColor" d="M512 1248V544q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23m256 0V544q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23m256 0V544q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23M480 256h448l-48-117q-7-9-17-11H546q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5H288q-66 0-113-58.5T128 1336V384H32q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23"/></svg>
                                            </div>
                                        </b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </div>
                        <div class="my-3">
                            <b-button type="submit" class="w-30" variant="primary">Update</b-button>
                        </div>
                    </b-form>
                </div>
            </b-card>
        </b-container>
    </div>
</template>
<script>
import { DatePicker, Select, Option } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Option.name]: Option,  
    },
    data() {
        return {
            form: {
                'target': '',
                'duration': '',
                'date_from': '',
                'date_to': ''
            },
            durationOptions: [
                {
                    label: 1,
                    value: 1,
                },
                {
                    label: 5,
                    value: 5,
                },
                {
                    label: 10,
                    value: 10,
                },
            ],
            targetList: [],
            errors: {
                target: false,
                duration: false,
                target_from: false,
                target_to: false
            }
        }
    },
    methods:{
        addRowTarget() {

            const allFieldsFilled = Object.values(this.form).every(value => value !== '')

            if(allFieldsFilled) {
                this.targetList.push({
                    target: this.form.target,
                    duration: this.form.duration,
                    date_from: this.form.date_from,
                    date_to: this.form.date_to,
                })

                this.form.target = ''
                this.form.duration = ''
                this.form.date_from = ''
                this.form.date_to = ''

                this.errors = {}
            }else {
                this.form.target == '' ? this.errors.target = true : this.errors.target = false
                this.form.duration == '' ? this.errors.duration = true : this.errors.duration = false
                this.form.date_from == '' ? this.errors.date_from = true : this.errors.date_from = false
                this.form.date_to == '' ? this.errors.date_to = true : this.errors.date_to = false
             }
        },
        removeRowTarget(index) {
            this.targetList.splice(index, 1)
        },
        update() {
            //
        },
    }
}
</script>